export { default } from './IconDownTriangle';
